import { formatPrice } from "@shared/core";

export const getPriceWithCurrency = (num: number | string, sign?: string, currency = '€') => {
  const str = num + '';
  if (!str) return '';
  return [
    sign,
    currency,
    formatPrice(str),
  ].filter(Boolean).join('')
}

export function getItemPrice(
  categoryFromCatalog: { items: { uid: string; price?: number }[] } | undefined,
  uid: string
): number {
  if (!categoryFromCatalog) return 0;

  const item = categoryFromCatalog.items.find((i) => i.uid === uid);
  return item?.price ?? 0;
}
